export const OptionsSources = Object.freeze({
    LEGEND: "legend",
    COLLECTION: "collection",
    BOOLEAN: "boolean",
    INLINE: "inline"
})